import { recordActivityActions } from "utils/constants";

interface initState {
  err: boolean;
  patientsList: { name: string; value: any }[];
  adminList: { name: string; value: any }[];
  prescriptionsList: { name: string; value: any }[];
  activitiesList: { name: string; value: any }[];
  practitionersList: { name: string; value: any }[];
}

export const createIntState: initState = {
  err: false,
  patientsList: [],
  adminList: [],
  activitiesList: [],
  practitionersList: [],
  prescriptionsList: [{ name: "No Prescription", value: "" }],
};

export function createIntReducer(
  state: initState,
  action: { type: any; payload: any }
) {
  switch (action.type) {
    case recordActivityActions.addActivitiesList:
      return {
        ...state,
        activitiesList: action.payload,
      };
    case recordActivityActions.addPatientsList:
      return {
        ...state,
        patientsList: action.payload,
      };
    case recordActivityActions.addAdminList:
      return {
        ...state,
        adminList: action.payload,
      };
    case recordActivityActions.addPractitionersList:
      return {
        ...state,
        practitionersList: action.payload,
      };
    case recordActivityActions.addPrescriptionList:
      return {
        ...state,
        prescriptionsList: action.payload,
      };
    default:
      return;
  }
}
